<script setup>
import { useGlobalStore } from '@stores/global'
import { gsap } from 'gsap'
import { Navigation } from 'swiper/modules'
import { onMounted, ref } from 'vue'

import Button from '@components/global/button.vue'

const global = useGlobalStore()
</script>
<template>
	<section class="container flex flex-col gap-10 lg:flex-row">
		<div class="flex w-full flex-col gap-6 pt-5 lg:w-half lg:pt-0">
			<span class="h9">Behind the scenes</span>
			<h3 class="mt-4 font-extrabold">Meet the garden</h3>
			<!-- <span class="text-sm text-primaryLight">Lorem ipsum dolor sit, amet consectetur adipisicing elit. In dolorem reiciendis laboriosam veritatis cumque ipsa mollitia esse doloremque voluptate! Enim corrupti laudantium aut incidunt natus illo tempora minus repellendus similique?</span> -->
		</div>

		<div class="w-full overflow-hidden lg:w-[65%]">
			<div style="padding: 56.25% 0 0 0; position: relative"><iframe src="https://player.vimeo.com/video/1111060821?h=c4a3968974&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%" title="Garden Mother x Impressed"></iframe></div>
		</div>
	</section>
</template>
